import React from "react";
import { format } from "date-fns";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Svg,
  Path,
  G,
} from "@react-pdf/renderer";

const LogoForPDF = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 143 57"
    width="60"
    height="24"
  >
    <G fill="none">
      <Path
        fill="white"
        d="M28.965 10.248l-.709 3.796c-.083.448-.5.816-.958.816h-8.46c-1.708 0-2.75.326-3.166 2.733l-.667 3.754h10.793c.417 0 .667.286.667.694v.122l-.667 3.878c-.083.448-.542.816-1 .816H14.005l-.792 4.325c-.083.408-.125.775-.125 1.06 0 1.307.709 1.715 2.292 1.715h8.46c.416 0 .708.286.708.693v.124l-.709 3.793c-.083.531-.374.776-.958.857-1.5.205-3.583.531-8.084.531-4.334 0-8.876-1.51-8.876-6.774 0-.61.083-1.305.208-1.999l2.459-13.548c1.417-7.916 6.042-8.732 11.751-8.732 4.5 0 6.5.326 7.917.53.5.082.751.205.751.572 0 .082-.042.163-.042.244M53.89 34.774l-.708 3.793c-.083.531-.333.735-.958.857-1.417.286-4.71.531-6.917.531-4.585 0-8.793-1.59-8.793-6.732 0-.613.083-1.306.208-2.04l3.792-21.098c.084-.449.542-.816 1-.816h5.46c.416 0 .666.285.666.653v.163l-3.792 21.097c-.083.408-.125.775-.125 1.06 0 1.307.708 1.715 2.292 1.715h7.167c.417 0 .709.286.709.693v.124M86.474 10.044l-.75 4.204c-.083.448-.583.775-1.041.775h-6.751l-4.25 23.749c-.084.448-.542.816-1.001.816h-5.459c-.416 0-.667-.286-.667-.653v-.163l4.251-23.75h-6.792c-.417 0-.667-.244-.667-.611v-.163l.75-4.204c.083-.448.5-.775.958-.775h20.669c.417 0 .75.285.75.653v.122"
      />
      <Path
        fill="white"
        d="M95.577 4.185c-.96-1.86-2.938-2.996-5.872-3.598C87.91.218 86.32 0 84.256 0h-.012c-.279 0-.567.004-.865.012-1.192.033-1.995.025-3.753.269-.868.12-1.343.249-1.37.247.285.01.877-.019 1.651-.046 1.178-.043 2.774-.085 4.347.002 1.84.103 3.647.48 4.707.812 1.402.439 2.99 1.32 3.558 2.44 2.582 5.088-3.946 13.88-15.81 22.938l-1.117 6.237c15.121-11 23.057-22.775 19.985-28.726"
      />
      <Path
        fill="white"
        d="M66.607 33.626c-3.827 2.392-7.964 4.74-12.341 6.979C29.27 53.39 6.308 57.047 2.217 49.935c-1.298-2.257-.721-5.33 1.239-8.778C1.225 44.215.008 46.997 0 49.317v.042c.003.939.205 1.801.62 2.575 4.724 8.812 28.752 5.744 57.066-8.262 2.747-1.358 5.376-2.778 7.881-4.238l1.04-5.808"
      />
      <Path
        fill="white"
        d="M117.262 10.247l-.692 3.782c-.08.447-.488.813-.936.813h-8.258c-1.668 0-2.685.325-3.092 2.724l-.651 3.741h10.536c.407 0 .652.285.652.691v.122l-.652 3.862c-.081.448-.528.814-.975.814h-10.537l-.772 4.31c-.083.406-.123.773-.123 1.057 0 1.302.69 1.708 2.237 1.708h8.259c.406 0 .691.285.691.691v.122l-.691 3.781c-.082.529-.367.773-.936.854-1.464.204-3.498.529-7.892.529-4.23 0-8.666-1.504-8.666-6.75 0-.61.082-1.3.204-1.992l2.4-13.5c1.383-7.887 5.899-8.7 11.472-8.7 4.394 0 6.347.325 7.73.528.488.082.732.204.732.57 0 .081-.04.162-.04.243M141.665 34.684l-.692 3.781c-.081.529-.325.733-.936.854-1.383.285-4.597.529-6.752.529-4.475 0-8.585-1.586-8.585-6.709 0-.61.083-1.3.204-2.033l3.702-21.021c.081-.448.53-.814.977-.814h5.329c.406 0 .65.285.65.65v.164l-3.701 21.021c-.082.406-.122.773-.122 1.057 0 1.302.692 1.708 2.238 1.708h6.996c.408 0 .692.285.692.691v.122M66.557 38.932c0 .375.251.667.67.667h5.483c.46 0 .92-.376 1.004-.834l1.98-11.242c-.64.45-1.331.976-2.04 1.457-1.923 1.35-3.957 2.7-6.085 4.037l-1.012 5.748v.167"
      />
    </G>
  </Svg>
);

const FooterContent = () => (
  <View style={styles.pageFooter} fixed>
    <View style={styles.footerLeftSection}>
      <Text style={styles.footerText}>Eltel Networks Infranet AB</Text>
      <Text style={styles.footerText}>
        BOX 202 11 SE, 161 02 Bromma, SWEDEN
      </Text>
      <Text style={styles.footerText}>Adolfsbergsvägen 13, Bromma</Text>
      <Text style={styles.footerLink}>www.eltelnetworks.se</Text>
    </View>
    <View style={styles.footerCenterSection}>
      <Text style={styles.footerText}>Tel +46 8 585 376 00</Text>
    </View>
    <View style={styles.footerRightSection}>
      <Text style={styles.footerText}>ORG. nr 556555-1073</Text>
      <Text style={styles.footerText}>Copyright © Eltel AB</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 30,
    paddingBottom: 80,
  },
  header: {
    marginBottom: 20,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#243E90",
    color: "#fff",
    borderRadius: 5,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minHeight: 60,
    position: "relative",
  },
  logoContainer: {
    width: 80,
    paddingLeft: 10,
    display: "flex",
    alignItems: "center",
  },
  headerTitleContainer: {
    position: "absolute",
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  workOrderNo: {
    fontSize: 14,
    marginBottom: 5,
  },
  section: {
    margin: 10,
    padding: 10,
    backgroundColor: "#f2f2f2",
    borderRadius: 8,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
    marginBottom: 5,
    minHeight: 14,
  },
  label: {
    width: "30%",
    fontWeight: "bold",
    fontSize: 10,
  },
  value: {
    width: "70%",
    fontSize: 10,
  },
  deliveryBlock: {
    marginTop: 10,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: "#d9d9d9",
  },
  deliveryHeader: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 6,
  },
  deliveryColumns: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  deliveryColumn: {
    flexBasis: "48%",
    marginBottom: 8,
  },
  deliveryTermsColumn: {
    flexBasis: "45%",
  },
  deliveryField: {
    marginBottom: 6,
  },
  deliveryLabel: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  deliveryValueLine: {
    fontSize: 10,
    marginBottom: 2,
  },
  deliveryFallback: {
    fontSize: 10,
    fontStyle: "italic",
  },
  subHeader: {
    marginBottom: 20,
    fontSize: 11,
  },
  woDescription: {
    fontSize: 11,
  },
  pageFooter: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 8,
    color: "#000",
  },
  footerLeftSection: {
    flex: 1,
    alignItems: "flex-start",
  },
  footerCenterSection: {
    flex: 1,
    alignItems: "center",
  },
  footerRightSection: {
    flex: 1,
    alignItems: "flex-end",
  },
  footerText: {
    marginBottom: 2,
  },
  footerLink: {
    marginBottom: 2,
    textDecoration: "underline",
    color: "#243E90",
  },
});

const shouldRenderSection = (stepIndex, formToShow) => {
  // Step 1 and 8 are always shown
  if (stepIndex === 1 || stepIndex === 8) return true;

  // For other steps, check if they exist and are activated
  return formToShow.some(
    (item) => item.Index === stepIndex && item.IsActivated
  );
};

const formatDate = (date) => {
  return format(date, "yyyy-MM-dd HH:mm");
};

const formatDateString = (dateString) => {
  if (!dateString) return "-";

  if (dateString.includes("T")) {
    const date = new Date(dateString);
    return format(date, "yyyy-MM-dd HH:mm");
  }

  return dateString;
};

const formatAddressLines = (value) => {
  if (!value) {
    return [];
  }

  return value
    .split(",")
    .map((part) => part.trim())
    .filter((part) => part.length >= 3);
};

const WorkOrderPDF = ({ workOrderData, wono, formToShow, deliveryInfo }) => {
  const sendMaterialValue = workOrderData.sendMaterial;
  const showDeliveryInfo = sendMaterialValue === "YES";

  const addressRows = [
    {
      label: "Leveransadress",
      value: formatAddressLines(deliveryInfo?.LeveransAdress),
    },
    {
      label: "Leveransmottagare",
      value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    },
    // {
    //   label: "Alternativ leveransmottagare",
    //   value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    // },
  ];

  const filteredAddressRows = addressRows.filter((row) => row.value.length > 0);

  const deliveryTermsRows = [
    {
      label: "Bemanning dagtid",
      value: deliveryInfo?.Bemanning_dagtid,
    },
    {
      label: "Tar emot EU pall",
      value: deliveryInfo?.Tar_emot_pallar,
    },
    {
      label: "Förvaring inomhus",
      value: deliveryInfo?.["Förvaring_inomhus"],
    },
  ];

  const filteredDeliveryTermsRows = deliveryTermsRows.filter(
    (row) => row.value !== "-"
  );
  const hasDeliveryDetails =
    filteredAddressRows.length > 0 || filteredDeliveryTermsRows.length > 0;

  const sendMaterialDisplay =
    sendMaterialValue === "YES"
      ? "Ja"
      : sendMaterialValue === "NO"
        ? "Nej"
        : "-";

  const hasProductCatalogueItems =
    Array.isArray(workOrderData.productCatalogueItems) &&
    workOrderData.productCatalogueItems.length > 0;

  const productLabel =
    hasProductCatalogueItems && workOrderData.productCatalogueItems.length > 1
      ? "Beställda produkter:"
      : "Beställd produkt:";

  const productDisplay = hasProductCatalogueItems
    ? workOrderData.productCatalogueItems
        .map((item) => `${item.groupCode}-${item.code} (${item.amount || 0})`)
        .join(", ")
    : workOrderData.product || "-";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.logoContainer}>
            <LogoForPDF />
          </View>
          <View style={styles.headerTitleContainer}>
            <Text style={styles.headerTitle}>Beställningsbekräftelse</Text>
          </View>
        </View>
        <View style={styles.subHeader}>
          <Text style={styles.workOrderNo}>Beställningsnummer: {wono}</Text>
          <Text>Beställningsdatum: {formatDate(new Date())}</Text>
        </View>

        {/* Step 1 - General info is always shown */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Grundläggande information</Text>
          <View style={styles.row}>
            <Text style={styles.label}>Kort beskrivning:</Text>
            <Text style={styles.value}>{workOrderData.shortDesc || "-"}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Ref nr:</Text>
            <Text style={styles.value}>
              {workOrderData.referensnummer || "-"}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Beställare:</Text>
            <Text style={styles.value}>
              {workOrderData.clientContact || "-"}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Telefon:</Text>
            <Text style={styles.value}>{workOrderData.clientPhone || "-"}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Email:</Text>
            <Text style={styles.value}>
              {workOrderData.clientContactEmail || "-"}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>
              Email statusavisering (annan mottagare än beställare):
            </Text>
            <Text style={styles.value}>
              {workOrderData.statusUpdatesEmail || "-"}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Önskad starttid:</Text>
            <Text style={styles.value}>
              {formatDateString(workOrderData.requiredStartDate)}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Önskad sluttid:</Text>
            <Text style={styles.value}>
              {formatDateString(workOrderData.requiredEndDate)}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>{productLabel}</Text>
            <Text style={styles.value}>{productDisplay}</Text>
          </View>
        </View>

        {/* Step 2 - Customer information */}
        {shouldRenderSection(2, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>
              Kontaktinformation för felavhjälpning eller installation
            </Text>
            <View style={styles.row}>
              <Text style={styles.label}>Namn:</Text>
              <Text style={styles.value}>
                {workOrderData.customerName || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Telefon:</Text>
              <Text style={styles.value}>
                {workOrderData.customerPhone || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Adress:</Text>
              <Text style={styles.value}>
                {workOrderData.customerAddress || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Postnummer och ort:</Text>
              <Text style={styles.value}>
                {workOrderData.customerPostalcode || "-"}{" "}
                {workOrderData.customerCity || ""}
              </Text>
            </View>
          </View>
        )}

        {/* Step 3 - Customer key info */}
        {shouldRenderSection(3, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>Åtkomst slutkund / företag</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Nyckel ID:</Text>
              <Text style={styles.value}>
                {workOrderData.customerKeyID || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Adress:</Text>
              <Text style={styles.value}>
                {workOrderData.customerKeyAddress || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Kontaktperson:</Text>
              <Text style={styles.value}>
                {workOrderData.customerKeyName || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Telefon:</Text>
              <Text style={styles.value}>
                {workOrderData.customerKeyPhone || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Ring för åtkomst/nyckel:</Text>
              <Text style={styles.value}>
                {workOrderData.customerCallForAccess || "-"}
              </Text>
            </View>
          </View>
        )}

        {/* Step 4 - Site details */}
        {shouldRenderSection(4, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>Site detaljer</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Site ID:</Text>
              <Text style={styles.value}>{workOrderData.siteID || "-"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Adress:</Text>
              <Text style={styles.value}>
                {workOrderData.siteAddress || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Postnummer och ort:</Text>
              <Text style={styles.value}>
                {workOrderData.sitePostalcode || "-"}{" "}
                {workOrderData.siteCity || ""}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Våning:</Text>
              <Text style={styles.value}>{workOrderData.siteFloor || "-"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Rad/Stativ:</Text>
              <Text style={styles.value}>{workOrderData.siteRow || "-"}</Text>
            </View>
          </View>
        )}

        {/* Step 5 - Site access */}
        {shouldRenderSection(5, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>Tillträde site</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Nyckel ID:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSiteKeyID || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Adress:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSiteAddress || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Postnummer och ort:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSitePostalcode || "-"}{" "}
                {workOrderData.accessSiteCity || ""}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Namn:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSiteName || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Telefon:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSitePhone || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Ring för åtkomst/nyckel:</Text>
              <Text style={styles.value}>
                {workOrderData.accessSiteCallForAccess || "-"}
              </Text>
            </View>
          </View>
        )}

        {/* Step 6 - Equipment / Connection */}
        {shouldRenderSection(6, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>
              Utrustning / Avlämningspunkt
            </Text>
            <View style={styles.row}>
              <Text style={styles.label}>Utrustnings ID:</Text>
              <Text style={styles.value}>
                {workOrderData.equipmentID || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Interface:</Text>
              <Text style={styles.value}>
                {workOrderData.equipmentInterface || "-"}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Förbindelsenummer:</Text>
              <Text style={styles.value}>
                {workOrderData.equipmentConnectionNumber || "-"}
              </Text>
            </View>
          </View>
        )}

        {/* Step 7 - Material details */}
        {shouldRenderSection(7, formToShow) && (
          <View style={styles.section} wrap={false}>
            <Text style={styles.sectionTitle}>Material & reservdelar</Text>
            <View style={styles.row}>
              <Text style={styles.label}>Skicka material:</Text>
              <Text style={styles.value}>{sendMaterialDisplay}</Text>
            </View>
            {showDeliveryInfo && (
              <View style={styles.deliveryBlock}>
                <Text style={styles.deliveryHeader}>Leveransinformation</Text>
                {deliveryInfo && hasDeliveryDetails ? (
                  <View style={styles.deliveryColumns}>
                    {filteredAddressRows.length > 0 && (
                      <View style={styles.deliveryColumn}>
                        {filteredAddressRows.map(({ label, value }) => (
                          <View key={label} style={styles.deliveryField}>
                            <Text style={styles.deliveryLabel}>{label}</Text>
                            {value.map((line, index) => (
                              <Text
                                key={`${label}-${index}`}
                                style={styles.deliveryValueLine}
                              >
                                {line}
                              </Text>
                            ))}
                          </View>
                        ))}
                      </View>
                    )}
                    {filteredDeliveryTermsRows.length > 0 && (
                      <View
                        style={[
                          styles.deliveryColumn,
                          styles.deliveryTermsColumn,
                        ]}
                      >
                        {filteredDeliveryTermsRows.map(({ label, value }) => (
                          <View key={label} style={styles.deliveryField}>
                            <Text style={styles.deliveryLabel}>{label}</Text>
                            <Text style={styles.deliveryValueLine}>
                              {value}
                            </Text>
                          </View>
                        ))}
                      </View>
                    )}
                  </View>
                ) : (
                  <Text style={styles.deliveryFallback}>
                    Ingen leveransinformation hittades.
                  </Text>
                )}
              </View>
            )}
            <View style={styles.row}>
              <Text style={styles.label}>Info returhantering:</Text>
              <Text style={styles.value}>
                {workOrderData.infoMtrlReturnMtrl || "-"}
              </Text>
            </View>
          </View>
        )}

        {/* Step 8 - Work description (allowed to wrap across pages; it can be
            arbitrarily long. Keeping wrap={false} here forces an oversized
            section onto one page, which corrupts react-pdf's layout pass and
            makes adjacent sections collapse/overlap.) */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Arbetsbeskrivning</Text>
          <Text style={styles.woDescription}>
            {workOrderData.longWorkDesc || "Ingen arbetsbeskrivning angiven"}
          </Text>
        </View>
        <FooterContent />
      </Page>
    </Document>
  );
};

export default WorkOrderPDF;
